import { LogLevel } from '@azure/msal-browser';
import { config } from '../../Config/AppConfig';

// Config object to be passed to Msal on creation
const msalConfig = {
  auth: {
    clientId: config.msal.CLIENT_ID,
    authority: config.msal.AUTHORITY,
    redirectUri: config.msal.REDIRECT_URI,
    postLogoutRedirectUri: config.msal.POST_LOGOUT_REDIRECT_URI,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            // console.error(message);
            break;
          case LogLevel.Info:
            // console.info(message);
            break;
          case LogLevel.Verbose:
            // console.debug(message);
            break;
          case LogLevel.Warning:
            // console.warn(message);
            break;
          default:
            break;
        }
      },
    },
  },
};

export default msalConfig;
